import * as React from 'react';
import { ButtonPrimary, ButtonSecondary } from 'ui';

import styles from './bowtie-connections.scss';

interface BowtieConnectionItemProps {
  connectionType: number;
  caseNumber: number;
  description: string;
  icon: string;
  connected: boolean;
  connectCase: (caseNumber: number, connectionType: number) => void;
  disconnectCase: (caseNumber: number, connectionType: number) => void;
}

export class BowtieConnectionItem extends React.PureComponent<BowtieConnectionItemProps> {

  private onClick = (ev: React.MouseEvent) => {

    const { caseNumber, connectionType, connected, connectCase, disconnectCase } = this.props;

    ev.preventDefault();

    if (connected) {
      disconnectCase(caseNumber, connectionType);
    } else {
      connectCase(caseNumber, connectionType);
    }
  };

  public render() {

    const { description, icon, connected } = this.props;

    const Item = connected ? ButtonPrimary : ButtonSecondary;

    return <Item
      classNames={styles.connectionItem}
      onClick={this.onClick}>
      {!!icon && <img src={icon} />}
      {description}
    </Item>;
  }
}
